export default "__VITE_ASSET__BfFyyeLp__"